import React from 'react';

import type {
  QuestionComponentProps
} from '../shared/QuestionComponent/QuestionComponent.react';
import {
  QuestionComponent
} from '../shared/QuestionComponent/QuestionComponent.react';

import {SnippetSelectionInputArea} from './SnippetSelectionInputArea.react';

const SnippetSelectionQuestionComponent = (props: QuestionComponentProps) => {
  return <QuestionComponent {...props} ActiveQuestionInputArea={SnippetSelectionInputArea} />;
};

type SnippetSelectionQuestionTypeProps = Omit<QuestionComponentProps, 'questionState'>;

const SnippetSelectionQuestion = {
  PreGuess: (props: SnippetSelectionQuestionTypeProps) => (
    <SnippetSelectionQuestionComponent {...props} questionState='PreGuess' />
  ),
  PostGuess: (props: SnippetSelectionQuestionTypeProps) => (
    <SnippetSelectionQuestionComponent {...props} questionState='PostGuess' />
  ),
  Dennis: (props: SnippetSelectionQuestionTypeProps) => (
    <SnippetSelectionQuestionComponent {...props} questionState='Dennis' />
  )
};

export {SnippetSelectionQuestion};
